import * as React from "react";
import { GhostWrap } from "./styles";

type Props = {};
type State = {};

class ZLoader extends React.Component<Props, State> {
  public readonly state: State = {};

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render(): JSX.Element {
    return (
      <React.Suspense fallback="">
        <GhostWrap>
          <div className="loading">
            <p>Z</p>
          </div>
        </GhostWrap>
      </React.Suspense>
    );
  }
}

export default ZLoader;
